var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.value
    ? _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-card",
                [
                  _c("w-card-title", [_vm._v(_vm._s(_vm.tab.Name))]),
                  _c(
                    "w-card-content",
                    [
                      _vm.readonly
                        ? _c("app-extra-fields-info", {
                            attrs: {
                              value: _vm.value,
                              "name-settings": _vm.nameSettings,
                              "tab-id": _vm.tab.ID,
                            },
                          })
                        : _c("app-extra-fields-edit", {
                            attrs: {
                              value: _vm.value,
                              "name-settings": _vm.nameSettings,
                              "tab-id": _vm.tab.ID,
                            },
                          }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }